export default {"src":"/_next/static/media/search-icon.f50f71c3.svg","height":22,"width":20};